import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Patterns, Input } from '@treezor/design-system';

import { openModal } from '@/store/actions/core.actions';

import { IOnboardingConfig } from '@/store/types/integration-config.types';
import { Page } from '@/ui-kit/templates/Page';

import { IUpdateOnboardingConfigModalProps } from './UpdateOnboardingConfigModal';

interface IConfigOnboardingFormState {
  onboardingSuccess: string;
  onboardingFail: string;
}

interface IConfigOnboardingProps {
  onboardingUrlConfig: IOnboardingConfig;
}

export const ConfigOnboarding = ({ onboardingUrlConfig }: IConfigOnboardingProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    handleSubmit,
    register,
    watch,
    formState: { dirtyFields },
  } = useForm<IConfigOnboardingFormState>({
    defaultValues: {
      onboardingSuccess: onboardingUrlConfig.onboardingSuccessCallBack,
      onboardingFail: onboardingUrlConfig.onboardingErrorCallBack,
    },
  });

  const onSubmitForm = (data: IConfigOnboardingFormState) => {
    dispatch(
      openModal<IUpdateOnboardingConfigModalProps>('onboardingConfigURLModal', {
        onboardingErrorCallBack: data.onboardingFail,
        onboardingSuccessCallBack: data.onboardingSuccess,
      }),
    );
  };

  return (
    <Page
      title={t('pages.administration.configuration.onboarding.title')}
      actions={[
        {
          id: 'update_onboarding_url',
          onClick: handleSubmit(onSubmitForm),
          label: t('pages.administration.configuration.onboarding.forms.saveBtn'),
          color: 'default',
          disabled: !Boolean(dirtyFields.onboardingFail || dirtyFields.onboardingSuccess),
        },
      ]}
    >
      <div className="flex justify-start flex-col mt-5 gap-5 w-[50%]">
        <Input
          type="text"
          label={t('pages.administration.configuration.onboarding.forms.onboardingSuccess')}
          value={watch('onboardingSuccess')}
          {...register('onboardingSuccess', { pattern: Patterns.url })}
        />

        <Input
          type="text"
          label={t('pages.administration.configuration.onboarding.forms.onboardingFail')}
          value={watch('onboardingFail')}
          {...register('onboardingFail', { pattern: Patterns.url })}
        />
      </div>
    </Page>
  );
};
